export default {
  apiGetAuditLogs(data) {
    let payload = { ...data };
    return this.request(this.api().IT_GET_AUDIT_LOGS, payload)
      .exec()
      .log()
      .mapresults((response) => {
        return response;
      })
      .get();
  },
};
